import React from "react";
import { HashLink } from "react-router-hash-link";

export const Navigation = () => {
  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            <span className="sr-only">Toggle navigation</span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
          </button>

          {/* Logo */}
          <HashLink smooth to="/#page-top" className="navbar-brand">
            <img src="img/logo.png" className="img-responsive" alt="logo" />
          </HashLink>
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            <li>
              <HashLink smooth to="/#features">Features</HashLink>
            </li>
            <li>
              <HashLink smooth to="/#about">About</HashLink>
            </li>
            <li>
              <HashLink smooth to="/#services">Services</HashLink>
            </li>
            <li>
              <HashLink smooth to="/#portfolio">Gallery</HashLink>
            </li>
            <li>
              <HashLink smooth to="/#internship">Internship</HashLink>
            </li>
            <li>
              <HashLink smooth to="/#careers">Careers</HashLink>
            </li>
            <li>
              <HashLink smooth to="/#contact">Contact</HashLink>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
